import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import '../About.css';

const Education = () => {
  const solutions = ['Learning Management Systems', 'Student Information Systems', 'Online Course Platforms', 'Assessment Tools', 'Parent Portals', 'Administrative Software'];

  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
          <h1>Education Solutions</h1>
          <p>Learning management and student information systems for educational institutions</p>
        </div>
      </section>
      <section className="about-story">
        <div className="container">
          <div className="story-content">
            <h2>Empowering Education</h2>
            <p>We build comprehensive education technology solutions that enhance learning experiences, streamline administration, and improve communication between students, teachers, and parents.</p>
          </div>
        </div>
      </section>
      <section className="about-expertise">
        <div className="container">
          <div className="section-header"><h2>Education Solutions</h2></div>
          <div className="expertise-grid">{solutions.map((s, i) => <div key={i} className="expertise-item">{s}</div>)}</div>
        </div>
      </section>
      <section className="about-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Transform Education Technology</h2>
            <p>Contact us to discuss your educational software needs.</p>
            <Link to="/contact"><Button variant="contained" size="large" endIcon={<ArrowForwardIcon />} sx={{ backgroundColor: '#2271b1', color: '#ffffff', fontWeight: '600', padding: '14px 32px', fontSize: '15px', textTransform: 'none', borderRadius: '3px', boxShadow: '0 1px 0 #135e96', '&:hover': { backgroundColor: '#135e96' } }}>Contact Us</Button></Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Education;
